import React, { FC, useMemo, useState } from 'react';
import { ModeSwitch } from './ModeSwitch';
import {
    AppBar,
    Box,
    Button,
    CssBaseline,
    ThemeProvider,
    Toolbar,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedYear } from '../../features/yearSlice';
import { MobileMenu } from './MobileMenu';
import { getTheme } from '../../utils/getTheme';

interface Props {
    children: React.ReactNode;
}

export const Header: FC<Props> = ({ children }) => {
    const [toggleDarkMode, setToggleDarkMode] = useState(true);
    const dispatch = useDispatch();

    const theme = useMemo(() => getTheme(toggleDarkMode), [toggleDarkMode]);

    const themeBreakpoint = useTheme();
    const isMobile = useMediaQuery(themeBreakpoint.breakpoints.down('md'));

    const onToggleDarkTheme = () => {
        setToggleDarkMode(!toggleDarkMode);
    };

    const selectedYear: number = useSelector((state: any) => state.years.selectedYear);
    const years: number[] = useSelector((state: any) => state.years.years);

    const onYearSelect = (year: number) => {
        dispatch(setSelectedYear(year));
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <AppBar position="static" className="header">
                    <Toolbar sx={{ position: 'relative' }}>
                        {!isMobile && (
                            <ModeSwitch onToggleDarkMode={onToggleDarkTheme} toggleDarkMode={toggleDarkMode} />
                        )}
                        <Typography
                            variant="h6"
                            sx={{
                                position: 'absolute',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            Hello, Cycling World! 🚴
                        </Typography>

                        {/* Desktop Menu */}
                        {!isMobile && (
                            <Box sx={{ marginLeft: 'auto', display: 'flex', gap: 1 }}>
                                {years.map((item) => (
                                    <Button
                                        key={item}
                                        onClick={() => onYearSelect(item)}
                                        color="inherit"
                                        className={item === selectedYear ? 'active' : ''}
                                    >
                                        {item}
                                    </Button>
                                ))}
                            </Box>
                        )}

                        {/*Mobile Menu Button */}
                        {isMobile && (
                            <MobileMenu onToggleDarkTheme={onToggleDarkTheme} toggleDarkMode={toggleDarkMode} />
                        )}
                    </Toolbar>
                </AppBar>
                {children}
            </ThemeProvider>
        </>
    );
};
